var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),(_vm.isLoaded)?_c('div',[_vm._v("Loading...")]):_c('div',[_vm._v("Ready.")]),(_vm.time)?_c('div',[_vm._v(_vm._s(_vm.time))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }